import PessoaHipertensaoIcon from '@/components/icons/IndicadoresAps/eSFeAP/PessoaHipertensao.vue'

export default {
  value: 'c5',
  label: 'Pessoa hipertensa',
  iconType: 'component',
  iconComponent: PessoaHipertensaoIcon,
  buscaAtiva: {
    a: 'Pessoa sem avaliação de hipertensão em consulta médica ou de enfermagem. Últimos 6 meses contados a partir do final do quadrimestre atual para trás.',
    b: 'Pessoa ainda não tem registro de aferição da pressão arterial, realizado nos últimos 6 meses.',
    c: 'Pessoa ainda não tem visitas domiciliares por ACS/Tacs, com intervalo mínimo de 30 dias, realizadas nos últimos 12 meses.',
    d: 'Pessoa ainda não tem realizado registro de peso e altura, nos últimos 12 meses.',
  },
}
